import PropTypes from 'prop-types';
import { any, values } from 'rambdax';
import UserViewEnums from '@/constants/users/UserViewEnums';
import { useCurrentUser } from '@/lib/hooks/userData';

const hasIntersection = (arr1, arr2) =>
  any((arr1Item) => arr2?.includes(arr1Item), arr1);

const ShowForViews = ({ children, fallback, showFor }) => {
  const { views, isSuperAdmin } = useCurrentUser(true);

  if (hasIntersection(showFor, views)) {
    return children;
  }

  if (isSuperAdmin && showFor.includes(UserViewEnums.SUPER_ADMIN)) {
    return children;
  }

  return fallback;
};

ShowForViews.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node,
  showFor: PropTypes.arrayOf(PropTypes.oneOf(values(UserViewEnums))).isRequired,
};

ShowForViews.defaultProps = {
  fallback: null,
};

export default ShowForViews;
